import React from 'react';

import { FormattedMessage } from 'react-intl';
import LocationPinFilled from 'dibs-vg/dist/react/location-pin-filled';

import styles from './PdpRespGalleryTag.scss';

export function PdpRespGalleryTag() {
    return (
        <a
            className={styles.galleryLink}
            href="/info/gallery/"
            target="_blank"
            rel="noopener noreferrer"
            data-tn="gallery-link"
        >
            <div className={styles.locationIcon}>
                <LocationPinFilled className={styles.icon} />
            </div>
            <div className={styles.locationText}>
                <FormattedMessage
                    id="PdpRespGalleryTag.locationText"
                    defaultMessage="1stdibs Gallery"
                />
            </div>
        </a>
    );
}
